package ru.it_mozaika.sender.js.application.frames.subscribers.lists

import io.ktor.client.call.*
import js.core.ReadonlyRecord
import js.core.jso
import mui.material.*
import mui.system.responsive
import mui.system.sx
import oldcomponents.NotyType
import oldcomponents.showNotification
import react.*
import ru.it_mozaika.components.*
import ru.it_mozaika.sender.common.models.ColumnsFilter
import ru.it_mozaika.sender.common.models.SubscriptionList
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError
import ru.it_mozaika.sender.js.application.context.BackdropContext
import ru.it_mozaika.sender.js.application.frames.MainCard
import tanstack.react.table.useReactTable
import tanstack.table.core.*
import web.cssom.*
import mui.icons.material.AddCircleOutlineSharp
import mui.material.styles.TypographyVariant
import ru.it_mozaika.sender.js.application.components.subscribers.addSubscriptionListDialog
import ru.it_mozaika.components.commonTableSkeletonFrame
import ru.it_mozaika.sender.js.application.components.StoresSelect
import ru.it_mozaika.sender.js.application.context.useStore

val subscriptionListsFrame = VFC {
    val storeContext = useStore()
    val (lists, setLists) = useState(listOf<SubscriptionList>())
    val (selectedProperty, setSelectedProperty) = useState("")
    val (rowsPerPage, setRowsPerPage) = useState(10)
    val (page, setPage) = useState(0)
    val (size, setSize) = useState(0)
    val (checkedProperties, setCheckedProperties) = useState(listOf<String>())
    val (showFilter, setShowFilter) = useState(false)
    var (columnVisibility, setColumnVisibility) = useState<ReadonlyRecord<String, Boolean>>(jso {})
    val (columnOrder, setColumnOrder) = useState<ColumnOrderState>(jso {})
//    val (propertiesDict, setPropertiesDict) = useState<ColumnsFilter>()
    val (searchQuery, setSearchQuery) = useState("")
    val (propertiesFilter, setPropertiesFilter) = useState<List<ColumnsFilter>>(listOf())
    val backdrop = useContext(BackdropContext)
    val tableColumns = listOf("ID", "Наименование", "Внешний ID")
    val (selectedSubscriptionList, setSelectedSubscriptionList) = useState<List<SubscriptionList>>(listOf())
    val (showDialog, setShowDialog) = useState(false)
    val (selectedSubscription, setSelectedSubscription) = useState<SubscriptionList>()
    val currentStoreId = useMemo(storeContext.currentStoreId){
        storeContext.currentStoreId
    }
    val table = useReactTable<SubscriptionList>(
        options = jso {
            columns = useMemo(tableColumns) {
                tableColumns.map { column ->
                    jso<ColumnDef<SubscriptionList, Any?>> {
                        accessorFn = { list, _ ->
                            when (column) {
                                "ID" -> list.id
                                "Наименование" -> list.name
                                "Внешний ID" -> list.externalId.orEmpty()
                                else -> ""
                            }
                        }
                        cell = ColumnDefTemplate { context ->
                            val value = context.getValue().toString()
                            Box.create {
                                +value
                            }
                        }
                        id = column
                        header = StringOrTemplateHeader(column)
                    }
                }
            }.toTypedArray()
            this.data = useMemo(lists) { lists.toTypedArray() }
            this.state = jso {
                this.columnVisibility = columnVisibility
                this.columnOrder = columnOrder
            }
            this.onColumnVisibilityChange = {
                columnVisibility = it.unsafeCast<ReadonlyRecord<String, Boolean>>()
                setColumnVisibility(it.unsafeCast<ReadonlyRecord<String, Boolean>>())
            }
            this.onColumnOrderChange = {
                setColumnOrder(it.unsafeCast<Array<String>>())
            }
            this.getCoreRowModel = getCoreRowModel()
            this.debugTable = true
            this.debugHeaders = true
            this.debugColumns = true
        }
    )

    fun getData() {
        val query = mutableMapOf(
            "page" to (page + 1).toString(),
            "rows" to rowsPerPage.toString(),
        )
        if (searchQuery.isNotBlank()) {
            query += ("search" to searchQuery)
        }
        if (!currentStoreId.isNullOrBlank()){
            query += ("store" to currentStoreId)
        }
        backdrop.show()
        Http.get(
            "/subscribers/lists",
            query = query,
        ) { response ->
            response.checkResponseError()?.let {
                showNotification(it, NotyType.Error)
                return@get
            }
            val list = response.body<List<SubscriptionList>>()
            setLists(list)
            backdrop.hide()
        }
        Http.get(
            "/subscribers/lists/size",
            query = query
        ){response ->
            response.checkResponseError()?.let {
                showNotification(it, NotyType.Error)
                return@get
            }
            setSize(response.body<Int>())
        }
    }
    useEffect(rowsPerPage, searchQuery, page, currentStoreId) {
        getData()
    }
//    useEffect(lists) {
//        setSize(lists.size)
//    }
    addSubscriptionListDialog {
        isOpen = showDialog
        this.onClose = {
            setShowDialog(false)
            setSelectedSubscription(null)
            getData()
        }
        this.subscription = selectedSubscription
    }

    MainCard {
        CardHeader{
            title = Stack.create{
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Typography{
                    this.variant = TypographyVariant.h2
                    + "Списки подписок"
                }
                searchField {
                    this.onSearchQueryChange = {
                        setSearchQuery(it)
                    }
                }
                StoresSelect()
            }
            action = Stack.create {
                this.direction = responsive(StackDirection.row)
                this.divider = Divider.create {
                    orientation = Orientation.vertical
                }
                asDynamic().spacing = 2
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexStart
                }
                AvatarButton {
                    AddCircleOutlineSharp()
                    this.tooltipTitle = "Добавить подписку"
                    onClick = {
                        setSelectedSubscription(null)
                        setShowDialog(true)
                    }
                }
            }
        }
//        Toolbar {
//            sx {
//                display = Display.flex
//                flexWrap = FlexWrap.wrap
//                paddingTop = 7.px
//            }
//            Stack {
//                this.direction = responsive(StackDirection.row)
//                this.divider = Divider.create {
//                    orientation = Orientation.vertical
//                }
//                asDynamic().spacing = 2
//                sx {
//                    this.width = 100.pct
//                    border = 2.px
//                    this.alignItems = AlignItems.center
//                    this.justifyContent = JustifyContent.flexStart
//                }
//
//            }
//        }
        commonTableSkeletonFrame {
            this.showCheckBox = false
            currentSelected = selectedSubscriptionList.map { it.id }
            this.toolbarActions = Stack.create {
                this.direction = responsive(StackDirection.row)
                this.divider = Divider.create {
                    orientation = Orientation.vertical
                }
                asDynamic().spacing = 2
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexStart
                }
                if (checkedProperties.isNotEmpty()) {
                    filterOffButton {
                        this.propertiesFilter = checkedProperties
                        this.handleOnFilterOffClick = {
                            setCheckedProperties(listOf())
                            setPropertiesFilter(listOf())
                            setSearchQuery("")
                        }
                    }
                }

            }
            this.label = "subscription-list"
            this.propertiesFilter = propertiesFilter
            this.columnId = "ID"
            this.table = table
            this.onDoubleClickHandler = { id ->
                val selected = lists.find { it.id == id }
                setSelectedSubscription(selected)
                setShowDialog(true)
            }
            this.onPropertySelect = { property ->
                setSelectedProperty(property)
                if (showFilter) setShowFilter(false) else setShowFilter(true)
            }
            this.onSelectionChanged = { newSelected ->
                val newList = newSelected.mapNotNull { listID ->
                    val list = lists.find {
                        it.id == listID
                    }
                    list
                }
                setSelectedSubscriptionList(newList)
            }
        }
        TablePagination {
            this.page = page
            this.count = size
            this.onPageChange = { _, newPage ->
                setPage(newPage.toInt())
            }
            this.onRowsPerPageChange = { event ->
                setRowsPerPage(event.target.asDynamic().value as Int)
                setPage(0)
            }
            this.rowsPerPage = rowsPerPage
        }
    }
}